import {
  ArrowLeftRightIcon,
  CarIcon,
  CircleCheckBigIcon,
  CreditCardIcon,
  TagIcon,
  TruckIcon,
  UserIcon,
  FileTextIcon,
} from "lucide-react";

import {
  filterVisibleVehicleAssignmentDefinitions,
  type VehicleAssignmentFlowContext,
  type VehicleAssignmentStepDefinition,
} from "@/lib/cat/vehicle-assignment-step-definitions";

const retailStepDefinitions: VehicleAssignmentStepDefinition[] = [
  {
    description: "Identification",
    icon: CarIcon,
    id: "vehicle_identification",
    title: "Véhicule",
  },
  {
    description: "Véhicule Carrossé",
    icon: TruckIcon,
    id: "vehicle_bodywork",
    title: "Véhicule Carrossé",
  },
  {
    description: "Particulier/Société",
    icon: UserIcon,
    id: "client",
    title: "Client",
  },
  {
    description: "Location & Financement",
    icon: CreditCardIcon,
    id: "leasing_financing",
    title: "Location",
  },
  {
    description: "Informations",
    icon: FileTextIcon,
    id: "additional_informations",
    title: "Informations complémentaires ",
  },
  {
    description: "Type de vente",
    icon: TagIcon,
    id: "selling_type_retail",
    title: "Type de vente",
  },
  {
    description: "Véhicule(s) repris",
    icon: ArrowLeftRightIcon,
    id: "vehicle_trade-in",
    title: "Reprise",
  },
  {
    description: "Récapitulatif & validation CTM",
    icon: CircleCheckBigIcon,
    id: "ctm_summary_validation",
    title: "Récapitulatif & validation CTM",
  },
];

function getRetailVehicleAssignmentVisibleDefinitions(
  ctx: VehicleAssignmentFlowContext,
): VehicleAssignmentStepDefinition[] {
  return filterVisibleVehicleAssignmentDefinitions(retailStepDefinitions, ctx);
}

export { getRetailVehicleAssignmentVisibleDefinitions, retailStepDefinitions };
